import { IParamsCourseObject } from '@/courses/interfaces/params-course-object.interface';
import { IParamsCreateFileObject } from '@/courses/interfaces/params-create-file-object.interface';
import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import EdCreateFileObject from '../ed-create-file-object/ed-create-file-object.vue';
import KEYS from '@/values/keys';
import { IResultCreateFileObject } from '@/courses/interfaces/result-create-file-object.interface';
import { SECTION_TYPES } from '@/content/values/sections';
import { CreateObjectsMixin } from '@/courses/mixins/create-objects.mixin';
import EdPdfRotatePages from '@/courses/components/ed-pdf-rotate-pages/ed-pdf-rotate-pages.vue'


@Component({
  components: {
    EdCreateFileObject,
    EdPdfRotatePages
  }
})
export default class EdCourseCreateZipStructureObject extends Mixins(CreateObjectsMixin) {

  // @Prop() readonly params: IParamsCourseObject;     //Typescript upgrade
  declare readonly params: IParamsCourseObject;   
  public isReadyToShow: boolean = true;
  acceptedFiles: any = '.zip';

  public createParams: IParamsCreateFileObject = {
    edition: false,
    homework: { show: false },
    grade: { show: false },
    labelSections: '',
  }; 
  public loaded: boolean = false;
  public fileComponent: any = null;

  get courseId() {
    return this.params.courseId;
  }

  get classId() {
    return this.params.classId;
  }

  get parentId() {
    return this.params.parentId;
  }

  get section() {
    return this.params.section;
  }

  onSave(fileObject: IResultCreateFileObject) {
    this.fileComponent = this.$refs.EdCreateFileObject;
    this.fileComponent.setSaving(true);
    this.saveFile(fileObject);
  }

  saveFile(fileObject: IResultCreateFileObject) {
    this.createObject({
      type: SECTION_TYPES.LESSON_ZIP.code,
      name: fileObject.name,
      file: fileObject.file,
      parentId: this.parentId,
      courseId: this.params.courseId,
      classId: this.params.classId,
      labelSections: fileObject.labelSections,
      component: fileObject.component,
    })
    .then(() => { this.onClose(); })
    .catch((error) => {
      this.onUploadEpubError(error);
    })
    .finally(() => {
      this.fileComponent.setSaving(false);
    });
  }

  onClose() {
    this.$EdModal.closeModal();
  }

  onUploadEpubError(error) {
    if(error.data && error.data.status === 400 && error.data.errors) {
      this.fileComponent = this.$refs.EdCreateFileObject;
      this.fileComponent.removeFile();
      let errors = error.data.errors[0];
      let message = String(this.$i18n.t(`courses.errors.codes.${errors.status}`));
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('courses.errors.errorTitle'),
        body: message,
        type: KEYS.EVENT_TYPES.DANGER
      });
    } else {
      this.$EdModal.createMessageModal({
        title: this.$i18n.t('courses.errors.errorTitle'),
        body: this.$i18n.t('courses.errors.errorSavingObject'),
        type: KEYS.EVENT_TYPES.DANGER
      });
    }
  }

  setIsReadyToShow(){
    this.isReadyToShow = false;
    setTimeout(() => {
      this.isReadyToShow = true;
    }
    , 500)
  }

  created() {
    this.createParams.title = String(this.$i18n.t('lesson.createLessonStructureByZip'));
    this.createParams.courseId = this.params.courseId;
    this.createParams.hasTagSelector = this.params.contentType === 'TEMPLATE';
    this.loaded = true;
  }

}